import { confirmationToast, errorToast, infoToast } from "@/components/ui/toast.tsx";

// Small helper for toasts that fire right before a page reload.
//
// Without this, the toast flashes for ~200ms and dies on reload — effectively invisible.
// stashToast() persists the toast intent to sessionStorage; the app's top-level mount
// effect calls consumePendingToast() on first render to replay it.
//
// Used by: account switcher's "switch account" flow + add-account success flows, both of
// which reload the page immediately after firing.

const PENDING_TOAST_KEY = "pendingToast";

type PendingToast =
  | { kind: "success"; message: string }
  | { kind: "info"; message: string }
  | { kind: "error"; message: string };

export const stashToast = (toast: PendingToast) => {
  try {
    sessionStorage.setItem(PENDING_TOAST_KEY, JSON.stringify(toast));
  } catch {
    // sessionStorage may be unavailable (private browsing, storage quota). Swallow —
    // the user loses the toast but doesn't lose the underlying success.
  }
};

export const consumePendingToast = () => {
  let raw: string | null;
  try {
    raw = sessionStorage.getItem(PENDING_TOAST_KEY);
    if (raw) sessionStorage.removeItem(PENDING_TOAST_KEY);
  } catch {
    return;
  }
  if (!raw) return;

  let parsed: PendingToast;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return;
  }

  if (parsed.kind === "success") {
    confirmationToast(parsed.message);
  } else if (parsed.kind === "info") {
    infoToast(parsed.message);
  } else if (parsed.kind === "error") {
    errorToast(parsed.message);
  }
};
